<div class="multi-charts">
  <!-- <div id="multi-charts-{{ this.elementSuffix }}"></div> -->
  <div id="multi-charts-{{ this.elementSuffix }}" class="multi-charts_container"></div>
  <app-water-mark></app-water-mark>
  <div *ngIf="!this.chartHeight" class="duration-label">Duration[mm:ss]</div>
</div>
